import styled from '@emotion/native'

export const ContentSeparator = styled.View(({ theme }) => ({
  height: theme.sizes.xs,
  borderBottomWidth: 2,
  borderBottomColor: theme.colors.foreground1,
  width: '100%',
}))
